(function () {
  const productItemSelector = '.product-item';
  const hiddenClass = 'product-item--has-visible-smells-like';
  const queuedItems = new Set();
  let scheduled = false;

  function isVisible(element) {
    if (!element || !element.textContent.trim()) {
      return false;
    }

    const style = window.getComputedStyle(element);
    return style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      element.getClientRects().length > 0;
  }

  function updateProductItem(productItem) {
    const hasVisibleSmellsLike = Array.from(productItem.querySelectorAll('.smells-like')).some(isVisible);
    productItem.classList.toggle(hiddenClass, hasVisibleSmellsLike);
  }

  function queueProductItem(productItem) {
    if (!productItem) {
      return;
    }

    queuedItems.add(productItem);

    if (!scheduled) {
      scheduled = true;
      window.requestAnimationFrame(flushQueue);
    }
  }

  function queueFromNode(node) {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) {
      return;
    }

    if (node.matches(productItemSelector)) {
      queueProductItem(node);
    }

    queueProductItem(node.closest(productItemSelector));
    node.querySelectorAll(productItemSelector).forEach(queueProductItem);
  }

  function flushQueue() {
    queuedItems.forEach(updateProductItem);
    queuedItems.clear();
    scheduled = false;
  }

  function init() {
    document.querySelectorAll(productItemSelector).forEach(updateProductItem);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        queueFromNode(mutation.target);
        mutation.addedNodes.forEach(queueFromNode);
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
